module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/62daf057b26b7bdbb44681fd60fe93aa.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_group_arrow_hover.svg
// module id = nn3e
// module chunks = 1